export default __webpack_public_path__ + "static/media/cs_icon_02_on.dc24a56a.png";